import { styled } from '@mui/material';
import { ReactNode } from 'react';

export type PageProps = {
  children: ReactNode;
};

const StyledPage = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
}));

export const Page = ({ children }: PageProps) => (
  <StyledPage>{children}</StyledPage>
);
